import React from "react";
import PropTypes from "prop-types";
import { IonButton } from "@ionic/react";
import ServingPlayerResult from "./ServingPlayerResult";
import ReceivingPlayerResult from "./ReceivingPlayerResult";

function ServiceResultSelection({ onAction, match, currentStatus }) {
  console.log("InGame", match, currentStatus);
  const isDouble = match.type === "double";
  debugger;
  const servingTeam = currentStatus.current_team;
  const servingPlayer = currentStatus.current_player;

  return (
    <div
      className="ion-padding"
      style={{
        display: "flex",
        gap: ".25rem",
        textAlign: "center",
        paddingTop: 0,
        paddingBottom: 0,
      }}
    >
      {servingTeam === "team_a" ? (
        <ServingPlayerResult servingPlayer={servingPlayer} onAction={onAction} />
      ) : (
        <ReceivingPlayerResult team={match.team_a} servingPlayer={servingPlayer} isDouble={isDouble} onAction={onAction} />
      )}
      {servingTeam === "team_b" ? (
        <ServingPlayerResult servingPlayer={servingPlayer} onAction={onAction} />
      ) : (
        <ReceivingPlayerResult team={match.team_b} servingPlayer={servingPlayer} isDouble={isDouble} onAction={onAction} />
      )}
    </div>
  );
}

ServiceResultSelection.propTypes = {
  onAction: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  currentStatus: PropTypes.object.isRequired,
};

export default ServiceResultSelection;
